import { useScanDeviceApiListQuery } from '@hooks/api/useScanDeviceApiListQuery';
import type { VrsType } from 'types/api';

export const useVrsTypes = useScanDeviceApiListQuery<VrsType>('/vrs-types');
